import { useCampaignHeaders } from '@/lib/useCampaignHeaders'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useEffect } from 'react'
import { raundUrl } from './custom'

//ログイン（追加）	signin
//カウント作成（追加）	account
//HOME画面	home
//スポット一覧（追加）	spots
//スポット詳細	spot_detail
//特典一覧	rewards
//特典詳細（追加）	reward_detail
//復元（追加）	restore
type PageType =
  | 'signin'
  | 'account'
  | 'home'
  | 'spots'
  | 'spot_detail'
  | 'rewards'
  | 'reward_detail'
  | 'restore'
  | 'photo_frame'
  | 'ocr'

interface LocationProps {
  latitude?: string
  longitude?: string
}

interface TrackingProps extends LocationProps {
  page: PageType
  optionalData?: string
}

interface TrackingResponse {
  getLocation: () => Promise<LocationProps>
  tracking: (trackingProps: TrackingProps) => Promise<void>
}

export const useTracking = ({ page, optionalData }: { page: PageType; optionalData?: string }): TrackingResponse => {
  const { LOCAL_STORAGE_JWT_KEY } = useCampaignSlug()
  const { headers, headersWithAuthorization } = useCampaignHeaders()
  const checkGeoLocationPermission = async (): Promise<boolean> => {
    if (navigator.permissions) {
      const result = await navigator.permissions.query({ name: 'geolocation' })
      if (result.state === 'granted') {
        return true
      }
    }
    return false
  }

  const getLocation = async (): Promise<LocationProps> => {
    const isGeoLocationAccessAllowed = await checkGeoLocationPermission()
    if (isGeoLocationAccessAllowed) {
      if (typeof navigator !== 'undefined' && navigator.geolocation) {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const latitude = position.coords.latitude.toString()
              const longitude = position.coords.longitude.toString()
              resolve({ latitude, longitude })
            },
            (error) => {
              resolve({})
            },
          )
        })
      } else {
        console.error('Geolocation is not supported by this browser.')
        return {}
      }
    }
    return {}
  }
  const tracking = async (trackingProps: TrackingProps) => {
    const authorization = localStorage.getItem(LOCAL_STORAGE_JWT_KEY)

    await fetch(raundUrl.tracking, {
      method: 'POST',
      body: JSON.stringify(trackingProps),
      headers: authorization ? headersWithAuthorization : headers,
    })
  }

  useEffect(() => {
    getLocation().then((v) => tracking({ page, optionalData, ...v }))
  }, [])

  return {
    getLocation,
    tracking,
  }
}
